import SalarieIdentifiant from '@/generated/controls/salarie/SalarieIdentifiant.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SalarieIdentifiant
})
